/* Bryzzo – kleine interacties (geen externe bibliotheken) */
(function () {
  'use strict';

  /* ---------- Tabs (afspraak / terugbellen) ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
    // Na het versturen van een formulier: het tabblad met de melding openen
    var notice = root.querySelector('[role="tabpanel"] .bz-notice');
    if (notice) {
      var panel = notice.closest('[role="tabpanel"]');
      var t = root.querySelector('[role="tab"][aria-controls="' + panel.id + '"]');
      if (t) {
        select(t, false);
        panel.scrollIntoView({ block: 'center' });
        notice.focus({ preventScroll: true });
      }
    }
  }
  document.querySelectorAll('[data-bz-tabs]').forEach(initTabs);

  /* ---------- Teller voor berichtvelden ---------- */
  document.querySelectorAll('textarea[data-bz-count]').forEach(function (ta) {
    var out = document.getElementById(ta.getAttribute('data-bz-count'));
    if (!out) return;
    var update = function () { out.textContent = ta.value.length; };
    ta.addEventListener('input', update);
    update();
  });

  /* ---------- Pakketprijzen per type organisatie ---------- */
  var priceData = document.getElementById('bz-prices');
  if (priceData) {
    var data;
    try { data = JSON.parse(priceData.textContent); } catch (e) { data = null; }
    if (data) {
      var lang = document.documentElement.lang || 'nl';
      var fmt = new Intl.NumberFormat(lang === 'nl' ? 'nl-NL' : lang, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      var buttons = document.querySelectorAll('[data-bz-segment]');
      var segLabel = document.querySelector('[data-bz-seg-label]');
      var apply = function (id) {
        var seg = data.segments[id];
        if (!seg) return;
        Object.keys(seg.prices).forEach(function (key) {
          document.querySelectorAll('[data-bz-price="' + key + '"]').forEach(function (el) {
            var v = seg.prices[key];
            el.textContent = (v === null) ? data.not_possible : fmt.format(v);
          });
        });
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bz-segment') === id ? 'true' : 'false'); });
        if (segLabel) segLabel.textContent = seg.label;
      };
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-bz-segment')); });
      });
      apply('s1');
    }
  }

  /* ---------- Mobiel menu: sluiten bij klik buiten of op een link ---------- */
  var burger = document.querySelector('.bz-burger');
  if (burger) {
    document.addEventListener('click', function (e) {
      if (burger.open && !burger.contains(e.target)) burger.open = false;
    });
    burger.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { burger.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.open) { burger.open = false; burger.querySelector('summary').focus(); }
    });
  }
})();
